import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import imageTrellis from '../assets/images/trellis-orange.png';
import media from '../styles/media';
import theme from '../styles/theme';
import Button from '../components/Button';

class ThankYou extends Component {
  constructor(props) {
    super(props);
    this.label = 'Back';
  }
  render() {
    return (
      <Root>
        <a href="https://trellisproperties.com/" target="_blank">
          <TrellisImage src={imageTrellis} />
        </a>
        <h2>Thank You for registering your interest.</h2>
        <p>
          We will soon be in touch with more infotmation about Trellis
          Properties and our current and future developments.
        </p>
        <Link to="/">
          <Button label={this.label} />
        </Link>
      </Root>
    );
  }
}

export default ThankYou;

const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 500px;
  top: 50%;
  transform: translateY(25%);
  button {
    margin-top: 0px;
  }
  h2 {
    width: 350px;
    text-align: center;
  }
  p {
    width: 350px;
    text-align: center;
    @media (min-width: ${media.sm}) {
      width: 450px;
    }
  }
`;

const TrellisImage = styled.img`
  width: 194px;
  height: 176px;
`;



// WEBPACK FOOTER //
// ./src/pages/ThankYou.js